export default "__VITE_ASSET__Bt6_tRVj__"